import { render, staticRenderFns } from "./CatalogMenu.vue?vue&type=template&id=47b52999&scoped=true"
import script from "./CatalogMenu.vue?vue&type=script&lang=js"
export * from "./CatalogMenu.vue?vue&type=script&lang=js"
import style0 from "./CatalogMenu.vue?vue&type=style&index=0&id=47b52999&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b52999",
  null
  
)

export default component.exports